<template>
  <div class="comments-item">
    <div class="user-bar">
      <div class="avatar">
        <img :src="link.user.avartar" alt="" />
      </div>
      <div class="user-info">
        <div class="row-1">
          <p class="nickname">{{ link.user.username }}</p>
          <img
            class="badge"
            v-if="link.user.medal && link.user.medal[0]"
            :src="link.user.medal[0].img_url"
            alt=""
          />
          <div class="level-box" v-if="link.user.level_info">
            <div class="level">Lv.{{ link.user.level_info.level }}</div>
          </div>
        </div>
        <div class="row-2">
          <div class="stars">
            <div
              class="star-box"
              :class="'star-' + parseInt(link.score)"
              v-if="link.score"
            >
              <i
                class="hb-star"
                v-for="star in parseInt(link.score)"
                :key="star"
                >&#xe684;</i
              >
            </div>
            <div class="star-box star-empty">
              <i
                class="hb-star hb-star-empty"
                v-for="star in 5 - parseInt(link.score)"
                :key="star"
                >&#xe684;</i
              >
            </div>
          </div>
          <p class="time" v-if="link.play_state">{{ link.play_state }}·</p>
          <div class="comment-time">{{ link.create_at | formatTime }}</div>
        </div>
      </div>
    </div>
    <div
      class="description"
      :class="{ limit: flag && !hasShow, expand: hasShow }"
    >
      {{ link.description }}
      <p class="btn-all" v-if="link.showBtn" @click="hasShow = !hasShow">
        {{ !hasShow ? '查看全文' : '点击收起' }}
      </p>
    </div>
    <div class="tools">
      <div class="left">
        <div class="item award-num" @click="openInHeybox">
          <OutOpen
            :protocol="protocol"
            :page-identifier="'game/detail'"
            v-if="canUseDeepLink"
          ></OutOpen>
          <div class="icon">
            <img
              src="https://imgheybox.max-c.com/oa/2022/08/19/5a9c680abc24649425646771c5f729ff.png"
              alt=""
            />
          </div>
          <span class="text">有用</span>
          <span class="num" v-if="link.link_award_num">{{
            link.link_award_num
          }}</span>
        </div>
        <div class="item down" @click="openInHeybox">
          <OutOpen
            :protocol="protocol"
            :page-identifier="'game/detail'"
            v-if="canUseDeepLink"
          ></OutOpen>
          <div class="icon">
            <img
              src="https://imgheybox.max-c.com/oa/2022/08/19/e8272d5422510e4d7bb26e84e74142e8.png"
              alt=""
            />
          </div>
          <span class="text">没用</span>
          <span class="num" v-if="link.down">{{ link.down }}</span>
        </div>
        <div class="item down" @click="openInHeybox">
          <OutOpen
            :protocol="protocol"
            :page-identifier="'game/detail'"
            v-if="canUseDeepLink"
          ></OutOpen>
          <div class="icon">
            <img
              src="https://imgheybox.max-c.com/oa/2022/08/19/c2eaba5fe29624eec13f6e97e37a6b3f.png"
              alt=""
            />
          </div>
          <span class="text">欢乐</span>
          <span class="num" v-if="link.happy">{{ link.happy }}</span>
        </div>
      </div>
      <div class="item right" @click="openInHeybox">
        <OutOpen
          :protocol="protocol"
          :page-identifier="'game/detail'"
          v-if="canUseDeepLink"
        ></OutOpen>
        <div class="icon">
          <img
            src="https://imgheybox.max-c.com/oa/2022/08/19/d40fa63467bb344ce5d6076644dfc5ad.png"
            alt=""
          />
        </div>
        <span class="text">讨论</span>
        <span class="num" v-if="link.comment_num">{{ link.comment_num }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import OutOpen from '_com/OutOpen';

export default {
  components: {
    OutOpen,
  },
  props: {
    link: {
      type: Object,
      default: () => {},
    },
    protocol: {
      type: String,
      default: '',
    },
    canUseDeepLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasShow: false,
      flag: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.flag = true;
    });
  },
  methods: {
    openInHeybox() {
      this.$parent.openInHeybox();
    },
  },
  filters: {
    formatTime(timestamp) {
      return moment(timestamp * 1000).format('YYYY-MM-DD');
    },
    formatPlayTime(seconds) {
      if (seconds > 3600) {
        return `${Math.round(seconds / 3600)}小时`;
      } else {
        return `${Math.round(seconds / 60)}分钟`;
      }
    },
  },
};
</script>

<style lang="less">
.comments-item {
  width: 100%;
  padding: 15px 12px 20px;
  position: relative;
  &:after {
    content: '';
    width: 100%;
    height: 4px;
    background-color: #fafbfc;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .tools {
    width: 100%;
    height: 24px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .item {
      display: flex;
      align-items: center;
      position: relative;
      padding: 4px 5px;
      background: #f7f8f9;
      border-radius: 2px;
      .icon {
        width: 16px;
        height: 16px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .text,
      .num {
        font-weight: 400;
        font-size: 11px;
        line-height: 16px;
        color: #64696e;
        white-space: nowrap;
      }
      .text {
        margin-left: 3px;
      }
      .num {
        margin-left: 2px;
      }
    }
    .left {
      display: flex;
      .item {
        &:not(:last-child) {
          margin-right: 8px;
        }
      }
    }
  }
  .description {
    line-height: 22px;
    font-size: 14px;
    color: #14191e;
    margin-top: 10px;
    position: relative;
    &.limit {
      max-height: 132px;
      overflow: hidden;
    }
    &.expand {
      margin-bottom: 24px;
      .btn-all {
        bottom: -21px;
      }
    }
    .btn-all {
      position: absolute;
      bottom: 0;
      right: 0;
      line-height: 22px;
      font-size: 14px;
      color: #004b96;
      background: #fff;
      padding-left: 10px;
      cursor: pointer;
      &::after {
        content: '';
        position: absolute;
        left: -40px;
        top: 0;
        height: 100%;
        width: 40px;
        background: linear-gradient(
          270deg,
          #ffffff 0%,
          rgba(255, 255, 255, 0) 100%
        );
      }
    }
  }
  .user-info {
    width: 0;
    flex: 1;
    margin-left: 10px;
    .row-2 {
      height: 14px;
      margin-top: 1px;
      display: flex;
      .stars {
        display: flex;
      }
      .star-box {
        line-height: 14px;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .hb-star {
          width: 10px;
          font-size: 10px;
          margin-right: 3px;
          color: transparent;
          vertical-align: top;
        }
      }
      .star-empty {
        margin-right: 6px;
      }
      .time,
      .comment-time,
      .point {
        line-height: 14px;
        font-size: 10px;
        color: #8c9196;
      }
    }
    .row-1 {
      width: 100%;
      height: 18px;
      display: flex;
      align-items: center;
      .level-box {
        height: 10px;
        margin-left: 6px;
        .level {
          height: 20px;
          line-height: 20px;
          padding: 0 6px;
          background-color: #ff0f00;
          transform-origin: top left;
          transform: scale(0.5);
          border-radius: 2px;
          color: #ffffff;
          font-size: 16px;
        }
      }
      .badge {
        width: 14px;
        height: 14px;
        margin-left: 6px;
      }
      .nickname {
        line-height: 18px;
        font-size: 14px;
        color: #14191e;
        font-weight: 500;
      }
    }
  }
  .award {
    display: flex;
    img {
      width: 20px;
      height: 20px;
    }
    p {
      height: 20px;
      line-height: 20px;
      margin-left: 4px;
      font-size: 12px;
      color: #c8cdd2;
    }
  }
  .user-bar {
    width: 100%;
    height: 34px;
    display: flex;
    .avatar {
      width: 34px;
      height: 34px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
        display: block;
      }
    }
  }
}
</style>
